import { tv } from 'tailwind-variants';

export const header = tv({
  slots: {
    base: 'flex w-full bg-transparent justify-between border-b border-gray-700 max-h-[73px] pl-[76px] md:pl-[16px]',
    nav: 'flex flex-row items-center border-l border-gray-700 py-3 px-6 gap-6',
  },
});
